import { Component, inject, OnInit, Renderer2, TemplateRef, ViewChild } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ConvivaErrorHandlingService } from "src/app/shared/services/convivaErrorHandlingService";

//Services
import { OAuthService } from "angular-oauth2-oidc";
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "src/app/shared/auth/services/auth.service";
import { EscolaService } from "src/app/shared/services/escola.service";
import { PerfilService } from "src/app/shared/services/perfil.service";
import { PsicologoService } from "src/app/shared/services/psicologo.service";

//Models
import { CommonModule } from "@angular/common";
import { NgSelectModule } from "@ng-select/ng-select";
import { lastValueFrom, of } from "rxjs";
import { catchError } from 'rxjs/operators';
import { authConfigMasp } from "src/app/shared/auth/models/auth-masp.config";
import { authConfig } from "src/app/shared/auth/models/auth.config";
import { Perfil } from "src/app/shared/enums/Perfis/Perfis";
import { DefaultResponse } from "src/app/shared/models/DefaultResponse";
import { Diretoria } from "src/app/shared/models/diretoria/Diretoria";
import { Escola } from "src/app/shared/models/escola/Escola";
import { Atribuicao, AtribuicaoLoginSed, AutorizaGovBr, PerfilLoginSed, UserLoginSed } from 'src/app/shared/models/sed/UserLogin';
import { GoogleAnalyticsService } from "src/app/shared/services/google-analytics.service";
import { ModalComponent } from "../../../../../components/modal/modal.component";

@Component({
  templateUrl: './gerenciar-login-masp.component.html',
  styleUrls: ['./gerenciar-login-masp.component.scss'],
  standalone: true,
  imports: [NgxSpinnerModule, ModalComponent, NgSelectModule, CommonModule, ReactiveFormsModule],
  providers: [GoogleAnalyticsService]
})

export class GerenciarLoginMaspComponent implements OnInit {
  //injeções
  route = inject(ActivatedRoute);
  router = inject(Router);
  toastr = inject(ToastrService);
  oauthService = inject(OAuthService);
  authService = inject(AuthService);
  perfilService = inject(PerfilService);
  spinnerService = inject(NgxSpinnerService);
  ConvivaErrors = inject(ConvivaErrorHandlingService);
  escolaService = inject(EscolaService);
  renderer = inject(Renderer2);
  psicologoService = inject(PsicologoService);
  gaService = inject(GoogleAnalyticsService);


  private error: string;

  constructor() {
    this.error = this.route.snapshot.queryParams.error;
    this.configure();
  }

  private configure() {
    this.oauthService.configure(authConfigMasp);
  }


  // Models
  public diretorias: Diretoria[] = [];
  public escolas: Escola[] = [];
  public usuario: UserLoginSed;
  public usuarioLogado: UserLoginSed;
  public resultPesquisa: boolean = false;
  public checkDiretoria: boolean = false;

  // Forms
  public formModalEscola!: FormGroup;
  public formModalPsicologo!: FormGroup;
  public get form() { return this.formModalEscola.controls; }
  public get codigoDiretoria() { return this.formModalEscola.get('codigoDiretoria')! }
  public get codigoEscola() { return this.formModalEscola.get('codigoEscola')! }

  // Modal
  @ViewChild('modalContent') modalContent!: TemplateRef<any>;
  public showModal = false;
  public showModalEscola = false;
  public showModalPsicologo = false;

  public async ngOnInit() {
    this.spinnerService.show();

    this.formModalEscola = new FormGroup({
      codigoDiretoria: new FormControl(null, [Validators.required]),
      codigoEscola: new FormControl(null, [Validators.required])
    });

    if (this.error != null && this.error != undefined && this.error != '') {
      this.toastr.error(this.error);
      this.spinnerService.hide();
      return;
    }

    try {
      await this.oauthService.tryLoginCodeFlow();

      if (this.oauthService.getAccessToken() == null) {
        this.authService.cleanStorageMasp();
        //faz login via govbr
        this.oauthService.configure(authConfig);
        await this.oauthService.loadDiscoveryDocumentAndTryLogin();
        this.oauthService.initCodeFlow();
        return;
      }
    } catch (e) {
      this.authService.cleanStorageMasp();
      //faz login via govbr
      this.oauthService.configure(authConfig);
      await this.oauthService.loadDiscoveryDocumentAndTryLogin();
      this.oauthService.initCodeFlow();
      return;
    }

    this.authService.setTokenMasp(this.oauthService.getAccessToken());

    this.authService.getTokenConviva().subscribe({
      next: async (response: DefaultResponse) => {
        if (response.isSucess) {
          const tokenSed = response.data.tokenConsumoConteudo;
          this.authService.setTokenConviva(tokenSed);
          await this.loginSed();
          return;
        }

        if (!response.isSucess) {
          this.toastr.error(response.message)

          setTimeout(() => {
            this.router.navigate(['/login']);
            this.spinnerService.hide();
          }, 5000);
        }
      },
      error: (error) => {
        this.spinnerService.hide();
        this.ConvivaErrors.handleError(error);
      }
    });
  }

  public getDiretoriasPerfilEscola(atribuicoes: AtribuicaoLoginSed[]) {

    this.diretorias = [];
    this.escolas = [];

    atribuicoes?.forEach((item: AtribuicaoLoginSed) => {
      const diretoria = new Diretoria();
      diretoria.codigoDiretoria = item.CodigoDiretoria;
      diretoria.nomeDiretoria = item.NomeDiretoria;
      this.diretorias.push(diretoria);

      // let escola = new Escola();
      // escola.codigoEscola = item.CodigoEscola;
      // escola.nomeEscola = item.NomeEscola;
      // escola.codigoDiretoria = item.CodigoDiretoria;
      // this.escolas.push(escola);
    });





    if (this.diretorias.length == 1 && this.escolas.length == 1) {
      this.form.codigoDiretoria.setValue(this.diretorias[0].codigoDiretoria);
      this.form.codigoDiretoria.disable();
      this.form.codigoEscola.setValue(this.escolas[0].codigoEscola);
      this.form.codigoEscola.disable();
    }
    if (this.diretorias.length == 1 && this.escolas.length > 1) {
      this.form.codigoDiretoria.setValue(this.diretorias[0].codigoDiretoria);
      this.form.codigoDiretoria.disable();
    }
  }
  // Método para verificar e aplicar o contraste
  private checkAndApplyContrast(): void {
    const contrastEnabled = localStorage.getItem('contrastEnabled') === 'true';
    const body = document.body;

    if (contrastEnabled) {
      this.renderer.setAttribute(body, 'id', 'contrast'); // Aplica o contraste
    } else {
      this.renderer.removeAttribute(body, 'id'); // Remove o contraste
    }
  }

  public async loginSed() {
    //var response = await lastValueFrom(this.authService.LoginSed());

    const response = await lastValueFrom(
      this.authService.LoginMasp().pipe(
        catchError((error) => {
          const retorno: AutorizaGovBr = {
            statusCode: error.status || 401,
            statusRetorno: error.error?.statusRetorno || error.message || 'Erro de autenticação',
            DadosUsuario: {
              CodigoUsuario: 0, Login: '', Nome: '', CPF: 0, Email: '', Perfis: []
            }
          };
          return of(retorno);
        })
      )
    );

    if (response.statusCode == 401) {
      this.toastr.error('Este login não está autorizado a acessar o CONVIVA. Verifique um login correto.', 'CONVIVA');
      this.toastr.error('Em 5 segundos iremos te redirecionar para o login.', 'CONVIVA');

      //await this.oauthService.loadDiscoveryDocument();
      this.authService.cleanStorageMasp();
      this.authService.cleanStorageGovBr();
      this.authService.cleanStorageConviva();
      this.oauthService.logOut();
    }

    if (response.statusCode == 200) {
      this.usuario = UserLoginSed.MappingUsuarioConviva(response);
      this.usuarioLogado = UserLoginSed.MappingUsuarioConviva(response);
      this.gaService.setUserId(this.usuario.codigoUsuario);
      if (this.usuario.perfis != null && this.usuario.perfis.length > 0) {
        await this.getAtribuicoes();
      } else {
        this.toastr.error("Nenhum perfil encontrado para este usuário");
        setTimeout(async () => await this.logout(), 3000);
      }
    }

  }

  public async onClickPerfil(cdUsuario: number, codigoPerfil: number, codigoComportamento: number) {
    this.form.codigoEscola.disable();
    this.spinnerService.show();
    const response = await lastValueFrom(this.authService.getAtribuicoesPerfil(cdUsuario, codigoPerfil));


    if (response.statusCode == 401) {
      this.toastr.error('Este login não está autorizado a acessar o CONVIVA.', 'CONVIVA');
      this.toastr.error('Em 5 segundos iremos te redirecionar para o login.', 'CONVIVA');
      this.spinnerService.hide();
      this.authService.cleanStorageGovBr();
      this.authService.cleanStorageMasp();
      this.authService.cleanStorageConviva();
      //await this.oauthService.loadDiscoveryDocument();
      this.oauthService.logOut();
    }

    if (response.statusCode == 200) {

      var perfilSelecionado = this.usuario.perfis.find((item: PerfilLoginSed) => item.codigoPerfil == codigoPerfil)

      if (codigoPerfil == Perfil.Psicólogo)
        await this.getLoginPsicologo();
      else {
        this.usuarioLogado.DadosUsuario[0].NumeroComportamento = perfilSelecionado!.codigoComportamento;
        this.usuarioLogado.DadosUsuario[0].NomePerfil = perfilSelecionado!.descricaoPerfil;
        this.usuarioLogado.DadosUsuario[0].CodigoPerfil = perfilSelecionado!.codigoPerfil;
        this.usuarioLogado.DadosUsuario[0].Comportamento = perfilSelecionado!.descricaoComportamento;
        this.usuarioLogado.nomePerfil = perfilSelecionado!.descricaoPerfil;
        this.usuarioLogado.codigoPerfil = perfilSelecionado!.codigoPerfil;
        this.usuarioLogado.NumeroComportamento = perfilSelecionado!.codigoComportamento.toString();
        this.usuarioLogado.cpf = String(this.usuarioLogado.DadosUsuario[0]!.Cpf);

        await this.setDadosPerfilUnico(response.DadosUsuario);

        await this.getDiretorias();
        await this.getFuncionalidades(codigoPerfil);
      }

    }


    if (response.statusCode == 201) {
      var perfilSelecionado = this.usuario.perfis.find((item: PerfilLoginSed) => item.codigoPerfil == codigoPerfil)
      this.usuarioLogado.DadosUsuario[0].NumeroComportamento = perfilSelecionado!.codigoComportamento;
      this.usuarioLogado.DadosUsuario[0].NomePerfil = perfilSelecionado!.descricaoPerfil;
      this.usuarioLogado.DadosUsuario[0].CodigoPerfil = perfilSelecionado!.codigoPerfil;
      this.usuarioLogado.DadosUsuario[0].Comportamento = perfilSelecionado!.descricaoComportamento;
      this.usuarioLogado.nomePerfil = perfilSelecionado!.descricaoPerfil;
      this.usuarioLogado.codigoPerfil = perfilSelecionado!.codigoPerfil;
      this.usuarioLogado.NumeroComportamento = perfilSelecionado!.codigoComportamento.toString();
      this.usuarioLogado.cpf = String(this.usuarioLogado.DadosUsuario[0]!.Cpf);

      this.getDiretoriasCombo();
      await this.getFuncionalidades(codigoPerfil);
    }




  }

  public async getPerfil(cdUsuari: number, codigoPerfil: number, codigoComportamento: number) {

    const response = await lastValueFrom(this.authService.getAtribuicoesPerfil(cdUsuari, codigoPerfil));

    if (response.statusCode == 200) {
      var perfil = this.usuario.perfis.find(item => item.codigoPerfil == codigoPerfil)
      this.usuarioLogado.DadosUsuario[0].NumeroComportamento = perfil!.codigoComportamento;
      this.usuarioLogado.DadosUsuario[0].NomePerfil = perfil!.descricaoPerfil;
      this.usuarioLogado.DadosUsuario[0].CodigoPerfil = perfil!.codigoPerfil;
      this.usuarioLogado.DadosUsuario[0].Comportamento = perfil!.descricaoComportamento;
      this.usuarioLogado.nomePerfil = perfil!.descricaoPerfil;
      this.usuarioLogado.codigoPerfil = perfil!.codigoPerfil;
      this.usuarioLogado.cpf = String(this.usuarioLogado.DadosUsuario[0]!.Cpf);
      this.usuarioLogado.NumeroComportamento = perfil!.codigoComportamento.toString();

      await this.setDadosPerfilUnico(response.DadosUsuario);
      await this.getDiretorias();
      if (codigoPerfil == 7) {
        codigoPerfil = 1634;
      }
      await this.getFuncionalidades(codigoPerfil);
    }

    if (response.statusCode == 401) {
      this.toastr.error('Este login não está autorizado a acessar o CONVIVA.', 'CONVIVA');
      this.toastr.error('Em 5 segundos iremos te redirecionar para o login.', 'CONVIVA');

      this.spinnerService.hide();
      this.authService.cleanStorageGovBr();
      this.authService.cleanStorageMasp();
      this.authService.cleanStorageConviva();
      //await this.oauthService.loadDiscoveryDocument();
      this.oauthService.logOut();
    }

    if (response.statusCode == 201) {

      var perfil = this.usuario.perfis.find(item => item.codigoPerfil == codigoPerfil)

      this.usuarioLogado.DadosUsuario[0].NumeroComportamento = perfil!.codigoComportamento;
      this.usuarioLogado.DadosUsuario[0].NomePerfil = perfil!.descricaoPerfil;
      this.usuarioLogado.DadosUsuario[0].CodigoPerfil = perfil!.codigoPerfil;
      this.usuarioLogado.DadosUsuario[0].Comportamento = perfil!.descricaoComportamento;

      this.usuarioLogado.nomePerfil = perfil!.descricaoPerfil;
      this.usuarioLogado.codigoPerfil = perfil!.codigoPerfil;
      this.usuarioLogado.cpf = String(this.usuarioLogado.DadosUsuario[0]!.Cpf);

      this.getDiretoriasCombo();
      await this.getFuncionalidades(codigoPerfil);
    }

  }

  public async logout() {

    this.spinnerService.show();
    //await this.oauthService.loadDiscoveryDocument();
    this.authService.cleanStorageGovBr();
    this.authService.cleanStorageMasp();
    this.authService.cleanStorageConviva();
    if (this.oauthService.hasValidAccessToken()) {
      this.spinnerService.hide();
      this.oauthService.logOut();
    }
    else {
      this.spinnerService.hide();
      this.router.navigate(['/logout']);
    }
  }

  public getDiretoriasCombo() {
    this.spinnerService.show();

    this.escolaService
      .getDiretoriaPorTipoDiretoria()
      .subscribe({
        next: (response: DefaultResponse) => {
          if (!response.isSucess) {
            this.toastr.error(response.message);
          }
          this.diretorias = response.data;
          this.spinnerService.hide();
        },
        error: (error) => {
          this.ConvivaErrors.handleError(error);
          this.spinnerService.hide();
        },
      });
  }

  public async getDiretorias() {

    this.diretorias = [];
    this.escolas = [];


    this.usuarioLogado?.DadosUsuario?.forEach(async (item: AtribuicaoLoginSed) => {

      const diretoria = new Diretoria();
      diretoria.codigoDiretoria = item.CodigoDiretoria;
      diretoria.nomeDiretoria = item.NomeDiretoria;
      if (this.usuarioLogado?.codigoDiretoria != undefined && this.usuarioLogado.codigoEscola != undefined) {
        if (this.usuarioLogado?.codigoDiretoria == diretoria.codigoDiretoria)
          this.diretorias.push(diretoria);
      }
      else
        this.diretorias.push(diretoria);
    });



    if (this.diretorias.length == 1 && this.escolas.length == 1) {
      this.form.codigoDiretoria.setValue(this.diretorias[0].codigoDiretoria);
      this.form.codigoDiretoria.disable();

      this.form.codigoEscola.setValue(this.escolas[0].codigoEscola);
      this.form.codigoEscola.disable();
    }

    if (this.diretorias.length == 1 && this.escolas.length > 1) {
      this.form.codigoDiretoria.setValue(this.diretorias[0].codigoDiretoria);
      this.form.codigoDiretoria.disable();
    }

    if (this.diretorias.length == 1 && this.escolas.length == 0) {
      this.form.codigoDiretoria.setValue(this.diretorias[0].codigoDiretoria);
      this.form.codigoDiretoria.disable();
      await this.getEscolas();
    }

  }

  public getDiretoriasPerfilDiretoria() {

    this.diretorias = [];
    this.escolas = [];

    this.usuarioLogado?.DadosUsuario?.forEach((item: AtribuicaoLoginSed) => {
      const diretoria = new Diretoria();
      diretoria.codigoDiretoria = item.CodigoDiretoria;
      diretoria.nomeDiretoria = item.NomeDiretoria;
      this.diretorias.push(diretoria);
    });

    if (this.diretorias.length == 1) {
      this.form.codigoDiretoria.setValue(this.diretorias[0].codigoDiretoria);
      this.form.codigoDiretoria.disable();

    }
  }

  public async getEscolas() {

    this.spinnerService.show();

    this.zerarEscola();
    const codigoDE = this.formModalEscola.get('codigoDiretoria');

    if (codigoDE?.value) {
      if (this.usuarioLogado.DadosUsuario[0]?.NumeroComportamento == 1 ||
        this.usuarioLogado.DadosUsuario[0]?.NumeroComportamento == 2 ||
        this.usuarioLogado.DadosUsuario[0].CodigoPerfil == Perfil.Psicólogo) {



        this.spinnerService.show();
        const response = await lastValueFrom(this.escolaService.getEscolasPorCodigoDiretoria(codigoDE?.value));
        if (!response.isSucess) {
          this.toastr.error(response.message);
        }
        this.escolas = response.data;
        this.form.codigoEscola.enable();
        this.spinnerService.hide();

      } else if (this.usuarioLogado.DadosUsuario[0]?.NumeroComportamento == 3 ||
        this.usuarioLogado.DadosUsuario[0]?.NumeroComportamento == 4) {


        const escolas: Escola[] = [];
        this.usuarioLogado?.DadosUsuario?.filter(x => x.CodigoDiretoria == codigoDE.value).forEach((item: AtribuicaoLoginSed) => {

          if (item.CodigoEscola && item.NomeEscola) {
            const escola: Escola = {
              codigoEscola: item.CodigoEscola,
              nomeEscola: item.NomeEscola,
              codigoDiretoria: item.CodigoDiretoria
            } as Escola;

            escolas.push(escola);

          }
        });
        this.escolas = escolas;
      }


      this.form.codigoEscola.enable();
    }

    this.spinnerService.hide();
  }

  public SelecionarEscola() {
    if (this.formModalEscola.invalid) {
      this.toastr.error('Favor de preencher a Diretoria e a Escola.', 'CONVIVA');
      return;
    }

    this.usuarioLogado.codigoDiretoria = this.formModalEscola.get('codigoDiretoria')?.value == null ? 0 : this.formModalEscola.get('codigoDiretoria')?.value;
    this.usuarioLogado.codigoEscola = this.checkDiretoria ? 0 : this.formModalEscola.get('codigoEscola')?.value == null ? 0 : this.formModalEscola.get('codigoEscola')?.value;
    this.usuarioLogado.apenasDiretoria = this.checkDiretoria;
    this.authService.setUser(this.usuarioLogado);

    if (this.usuarioLogado.codigoPerfil == 1656) {
      this.router.navigate(['/avaliacao-visita-fiscal']);
      return;
    }

    this.router.navigate(['/']);
  }

  public async FecharModalEscola() {
    this.spinnerService.show();
    //await this.oauthService.loadDiscoveryDocument();
    this.authService.cleanStorageGovBr();
    this.authService.cleanStorageConviva();
    this.authService.cleanStorageMasp();
    if (this.oauthService.hasValidAccessToken()) {
      this.spinnerService.hide();
      this.oauthService.logOut();
    }
    else {
      this.spinnerService.hide();
      this.router.navigate(['/logout']);
    }
  }

  public async getLoginPsicologo() {

    const response = await lastValueFrom(this.psicologoService.getPsicologoPorCPF(this.usuario.cpf))
      .catch(err => err);

    if (!response.isSucess) {
      this.toastr.error(response.message);

      setTimeout(async () => {
        //await this.oauthService.loadDiscoveryDocument();
        this.authService.cleanStorageGovBr();
        this.authService.cleanStorageConviva();
        this.authService.cleanStorageMasp();
        this.oauthService.logOut();
        this.spinnerService.hide();
      }, 3000);

      return;
    }

    if (response.data == null) {
      this.toastr.error("Psicólogo sem acesso ao Conviva.");

      setTimeout(async () => {
        //await this.oauthService.loadDiscoveryDocument();
        this.authService.cleanStorageGovBr();
        this.authService.cleanStorageConviva();
        this.authService.cleanStorageMasp();
        this.oauthService.logOut();
        this.spinnerService.hide();
      }, 3000);

    }
    this.PopulaPsicologo(response.data);
    await this.getFuncionalidade(this.usuarioLogado.perfis[0].codigoPerfil);
    await this.getDiretoriasPorPolo(this.usuarioLogado.codigoPolo);
    this.MostraModalEscola();
    this.authService.setUser(this.usuarioLogado);
    this.spinnerService.hide();

  }

  private async getDiretoriasPorPolo(codigoPolo: number) {
    const response = await lastValueFrom(this.psicologoService.getDiretoriaPorPolo(codigoPolo));
    if (!response.isSucess) {
      this.toastr.error(response.message)

      setTimeout(() => {
        this.router.navigate(['/login']);
        this.spinnerService.hide();
      }, 5000);
    }

    this.diretorias = response.data;
    this.form.codigoDiretoria.enable();
    return;
  }

  private PopulaPsicologo(userData: any) {

    this.usuarioLogado.flPsicologo = true;
    this.usuarioLogado.codigoPolo = userData.codigoPoloRegional;
    this.usuarioLogado.NumeroComportamento = '3';
    this.usuarioLogado.comportamento = 'Escola';
    this.usuarioLogado.nomePerfil = "Psicólogo";
    this.usuarioLogado.codigoPerfil = Perfil.Psicólogo;
    this.usuarioLogado.autorizacaoUsoDados = userData.autorizacaoDados;
    // this.usuarioLogado.cpf = userData.cpf;
    // this.usuarioLogado.nome = userData.nome;
    // this.usuarioLogado.login = userData.email;
    const atribuicao = this.usuarioLogado.DadosUsuario[0];
    atribuicao.CodigoPolo = userData.codigoPoloRegional;
    atribuicao.NumeroComportamento = 3;
    atribuicao.Comportamento = 'Escola';
    atribuicao.CodigoPerfil = Perfil.Psicólogo;
    this.usuarioLogado.DadosUsuario = [atribuicao];
  }

  public async getAtribuicoes() {
    const response = await lastValueFrom(this.perfilService.getPerfisUsuario(this.usuario.perfis));

    this.usuario.perfis = response.data;

    if (this.usuario?.perfis?.length == 0) {
      this.toastr.error('Este login não está autorizado a acessar o CONVIVA. Não tem Perfis na SED.', 'CONVIVA');
      this.toastr.error('Em 5 segundos iremos te redirecionar para o login.', 'CONVIVA');

      setTimeout(async () => {
        //await this.oauthService.loadDiscoveryDocument();
        this.authService.cleanStorageGovBr();
        this.authService.cleanStorageConviva();
        this.oauthService.logOut();
        return;
      }, 6000);
    }

    if (this.usuario?.perfis?.length > 1) {
      this.showModal = true;
      this.checkAndApplyContrast();
      this.spinnerService.hide();
      return;
    }

    if (this.usuario?.perfis?.length == 1) {

      if (this.usuario.perfis[0].codigoPerfil == Perfil.Psicólogo) {
        this.checkAndApplyContrast();
        await this.getLoginPsicologo();
      } else {
        await this.getPerfil(this.usuario.DadosUsuario[0].CodigoUsuario, this.usuario.perfis[0].codigoPerfil, this.usuario.perfis[0].codigoComportamento)
      }

      return;

    }

    this.spinnerService.hide();
  }

  public async getFuncionalidades(codigoPerfil: number) {

    if (codigoPerfil == 7) {
      codigoPerfil = 1634;
    }
    const response = await lastValueFrom(this.perfilService.getFuncionalidadesPerfil(codigoPerfil));

    await this.setLoginAnalytics();

    this.usuarioLogado.funcionalidades = response.data;
    this.spinnerService.hide();
    this.showModal = false;
    this.showModalEscola = true;
    // if(this.usuarioLogado.DadosUsuario[0]?.NumeroComportamento == 1)
    //   this.getDiretoriasCombo();
    // if(this.usuarioLogado.DadosUsuario[0]?.NumeroComportamento == 2)
    //   this.getDiretoriasPerfilDiretoria();
    if (this.usuarioLogado.DadosUsuario[0]?.NumeroComportamento == 3 ||
      this.usuarioLogado.DadosUsuario[0]?.NumeroComportamento == 4 &&
      this.usuarioLogado.DadosUsuario[0]?.CodigoPerfil != Perfil.Psicólogo)
      await this.getEscolas();

  }

  public async setLoginAnalytics() {
    await lastValueFrom(this.authService.setLoginAnalytics(
      this.usuarioLogado.codigoUsuario,
      this.usuarioLogado.nome,
      this.usuarioLogado.cpf,
      this.usuarioLogado.codigoPerfil,
      this.usuarioLogado.nomePerfil,
      this.usuarioLogado.NumeroComportamento
    ));
  }

  public async getFuncionalidade(codigoPerfil: number) {
    if (codigoPerfil == 7) {
      codigoPerfil = 1634;
    }
    const response = await lastValueFrom(this.perfilService.getFuncionalidadesPerfil(codigoPerfil));
    if (!response.isSucess) {
      this.toastr.error(response.message);
      return;
    }
    this.usuarioLogado.funcionalidades = response.data;
    await this.setLoginAnalytics();

  }
  private MostraModalEscola() {
    this.showModal = false;
    this.showModalEscola = true;
  }

  public async setDadosPerfilUnico(atribuicoes: Atribuicao[]) {
    const novosDadosUsuarios: AtribuicaoLoginSed[] = [];
    const dadosUsuario = this.usuarioLogado.DadosUsuario[0];

    for (const item of atribuicoes) {
      const polo = await lastValueFrom(this.psicologoService.getPolos(item.CodigoDiretoria))
        .catch(err => this.ConvivaErrors.handleResultError(err))

      const newAtribuicao = new AtribuicaoLoginSed();
      //Dados atribuições
      newAtribuicao.CodigoDiretoria = item.CodigoDiretoria;
      newAtribuicao.NomeDiretoria = item.NomeDiretoria;
      newAtribuicao.CodigoTurma = item.CodigoTurma;
      newAtribuicao.NomeEscola = item.NomeEscola;
      newAtribuicao.CodigoEscola = this.checkDiretoria ? 0 : item.CodigoEscola;
      newAtribuicao.LocadoDiretoria = this.checkDiretoria;
      newAtribuicao.CodigoPolo = polo.data[0].codigoPolo;
      //Dados cabeçalho
      newAtribuicao.NumeroComportamento = dadosUsuario.NumeroComportamento;
      newAtribuicao.Comportamento = dadosUsuario.Comportamento;
      newAtribuicao.CodigoPerfil = dadosUsuario.CodigoPerfil;
      newAtribuicao.NomePerfil = dadosUsuario.NomePerfil;
      newAtribuicao.Cpf = dadosUsuario.Cpf;
      newAtribuicao.Email = dadosUsuario.Email;
      newAtribuicao.Login = dadosUsuario.Login;
      newAtribuicao.CodigoUsuario = dadosUsuario.CodigoUsuario;
      newAtribuicao.DataInclusao = dadosUsuario.DataInclusao;
      newAtribuicao.Nome = dadosUsuario.Nome;

      novosDadosUsuarios.push(newAtribuicao);
    }

    this.usuarioLogado.DadosUsuario = novosDadosUsuarios;
  }

  public checkedDiretoria() {
    this.checkDiretoria = !this.checkDiretoria;
    if (!this.checkDiretoria) {
      this.form.codigoEscola.enable();
      this.form.codigoEscola.addValidators([Validators.required]);
      this.form.codigoEscola.updateValueAndValidity();
    } else {
      this.form.codigoEscola.clearValidators();
      this.form.codigoEscola.setValue(null);
      this.form.codigoEscola.disable();
      this.form.codigoEscola.updateValueAndValidity();
      this.usuarioLogado!.codigoEscola = 0;
      this.authService.setUser(this.usuarioLogado!);
    }
    this.form.codigoEscola.updateValueAndValidity();
  }



  zerarEscola() {
    this.escolas = [];
    this.form.codigoEscola.setValue(null);
    this.form.codigoEscola.disable();

  }
}
